






















































































































































import { readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { Datetime } from 'vue-datetime';
import { api } from '@/api';
import { dispatchGetTicketDetail } from '@/store/user_tasks/actions';
import { readTicketDetail } from '@/store/user_tasks/getters';

@Component({
  components: {
    FmvAvatar,
    Datetime,
  },
})
export default class NewLeadTaskModal extends Vue {
  // @ts-ignore
  @Prop({required: false, default: false}) readonly public isModal: boolean;
  // @ts-ignore
  @Prop({required: false, default: false}) readonly public showModal: boolean;
  // @ts-ignore
  @Prop({required: false, default: null}) readonly public ticketId: number | null;
  public formError = false;
  public startAt = 'now';
  public taskType = 2;
  public loadingState = {
    submit: false,
  };

  public async mounted() {
    if (this.ticketId) {
      await dispatchGetTicketDetail(
        this.$store, {ticket_id: Number(this.ticketId)},
      );
    } else {
      await dispatchGetTicketDetail(
        this.$store, {ticket_id: Number(this.$router.currentRoute.params.ticketId)},
      );
    }
    if (this.ticketDetail && this.ticketDetail.status) {
      // @ts-ignore
      this.showToast(this, this.$t('Ticket is already taken by another consultant'), 'error');
      if (!this.isModal) {
        this.$router.push('/staff-dashboard');
      } else {
        this.$emit('close-modal');
      }
    }
  }

  get ticketDetail() {
    return readTicketDetail(this.$store);
  }

  public validateForm() {
    if (!this.startAt) {
      // @ts-ignore
      this.showToast(this, this.$t('Please, select start time'), 'error');
      return false;
    } else {
      this.formError = false;
      return true;
    }
  }

  public resetForm() {
    this.startAt = 'now';
    this.taskType = 2;
    this.$emit('close-modal');
  }

  public async handleSubmit() {
    if (await this.validateForm()) {
      this.loadingState.submit = true;
      try {
        const response = await api.createNewLeadTask(
          this.$store.getters.token,
          {
            ticket_id: this.ticketId ? Number(this.ticketId) : Number(this.$router.currentRoute.params.ticketId),
            start_at: this.startAt,
            task_type: this.taskType,
          },
        );
        // @ts-ignore
        this.showToast(this, this.$t('Task created'));
        if (!this.isModal) {
          this.$router.push(`/staff-dashboard/?open_task=${response.data.task_id}`);
        } else {
          this.$emit('success-modal');
          // @ts-ignore
          this.$router.push(`/user/view-details/${this.ticketDetail.user.id}/?open_task=${response.data.task_id}`);
        }
      } catch (e) {
        // @ts-ignore
        if (e.response.data && e.response.data.ticket_id) {
          // @ts-ignore
          this.showToast(this, this.$t('Ticket is already taken by another consultant'), 'error');
        } else {
          // @ts-ignore
          this.showToast(this, this.$t('Error'), 'error');
        }
      }
      this.loadingState.submit = false;
    }
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  get startAtTypes() {
    return [
      {
        value: 'now',
        text: this.$t('Now'),
      },
      {
        value: 'today',
        text: this.$t('Today'),
      },
      {
        value: 'tomorrow',
        text: this.$t('Tomorrow'),
      },
    ];
  }

  get taskTypes() {
    return [
      {
        value: 2,
        text: this.$t('Call'),
      },
      {
        value: 1,
        text: this.$t('Meet'),
      },
      {
        value: 3,
        text: this.$t('Message'),
      },
      {
        value: 4,
        text: this.$t('Gift with a letter'),
      },
      {
        value: 5,
        text: this.$t('Letter'),
      },
    ];
  }

}
